import React, { useState, useEffect, Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';

// import { CLICK_TYPE, NOTIFICATION_TYPE } from 'common/components/notification-component/notification-component';
import { CLICK_TYPE, NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';
import { NOTIFICATION_ACTION, NOTIFICATION_MESSAGE } from 'home/view/manage-feasibility/constants/multiSite-constants';

export const OvRejection = ({ setNotification, orderDetail }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleNotficationEvent = ({ nodeInfo, event, innerText }) => {
    const { action } = nodeInfo;
    switch (action) {
      case NOTIFICATION_ACTION.VIEW_MORE:
        setIsExpanded(!isExpanded);
        break;
      default:
        break;
    }
  };

  const renderViewMoreReason = (remarks = []) => {
    const reasons = isExpanded ? remarks.slice(0, remarks.length) : remarks.slice(0, 1);
    const viewMore = (
      <a type="link" href="javascript:void(0);" role="button" tabindex="0">
        <strong id="link" data-type={CLICK_TYPE.LINK} data-name={NOTIFICATION_ACTION.VIEW_MORE} data-action={NOTIFICATION_ACTION.VIEW_MORE}>
          {' '}
          {reasons.length > 1 && isExpanded ? 'View less ' : 'View more...'}
        </strong>
      </a>
    );
    return (
      <Fragment>
        <ul className="view-more">
          {reasons.map((reason, index) => {
            return (
              <li key={uuidv4()}>
                {' '}
                {reason}. {index === (isExpanded ? remarks.length - 1 : 0) ? (remarks.length > 1 ? viewMore : '') : ''}
              </li>
            );
          })}
        </ul>
      </Fragment>
    );
  };

  useEffect(() => {
    if (orderDetail.orderStatus === 'OV_REJECTED') {
      const remarks = orderDetail ? orderDetail.remarks.split(',') : '';
      const notificationContent = (
        <React.Fragment>
          {' '}
          {NOTIFICATION_MESSAGE.ORDER_REJECTED_BEACUSE} {renderViewMoreReason(remarks)}{' '}
        </React.Fragment>
      );
      setNotification(false, notificationContent, NOTIFICATION_TYPE.WARNING, handleNotficationEvent, true);
    }
    return () => {
      setNotification(false);
    };
  }, [orderDetail, isExpanded]);

  return <Fragment></Fragment>;
};
